// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2TQBh","options":"AnswerScale_options__1HXq2","selected":"AnswerScale_selected__3Q_td"};